import vehicleMotoIcon from '../assets/icons/icon_vehicle_moto.png'
import vehicleCarIcon from '../assets/icons/icon_vehicle_car.png'
import vehicleElectricIcon from '../assets/icons/icon_vehicle_electric.png'

export const OPTIONS_VEHICLE_TYPE_INFO_VEHICLE = [
  { vehicleType: 30, label: 'Xe máy', value: 30, iconUrl: vehicleMotoIcon },
  { vehicleType: 1, label: 'Ô tô', value: 1, iconUrl: vehicleCarIcon },
  { vehicleType: 40, label: 'Xe máy điện', value: 40, iconUrl: vehicleElectricIcon }
]

